export const GCP_CONNECTION_SETTINGS_REQUEST = 'GCP_CONNECTION_SETTINGS_REQUEST'
export const GCP_CONNECTION_SETTINGS_SUCCESS = 'GCP_CONNECTION_SETTINGS_SUCCESS'
export const GCP_CONNECTION_SETTINGS_ERROR = 'GCP_CONNECTION_SETTINGS_ERROR'
export const GCP_CONNECTION_SETTINGS_SET = 'GCP_CONNECTION_SETTINGS_SET'

export const GCP_CONNECTION_SETTINGS_CREATE_REQUEST = 'GCP_CONNECTION_SETTINGS_CREATE_REQUEST'
export const GCP_CONNECTION_SETTINGS_UPDATE_REQUEST = 'GCP_CONNECTION_SETTINGS_UPDATE_REQUEST'
export const GCP_CONNECTION_SETTINGS_UPDATE_SUCCESS = 'GCP_CONNECTION_SETTINGS_UPDATE_SUCCESS'
export const GCP_CONNECTION_SETTINGS_UPDATE_ERROR = 'GCP_CONNECTION_SETTINGS_UPDATE_ERROR'



// WEBPACK FOOTER //
// ./src/store/modules/integrations/gcp-connection-settings.type.js